import React from 'react';
import { Input } from '@deere/fuel-react';

export const EditQuickLink = ({ selectedQuickLink, setSelectedQuickLink }) => (
    <>
        <strong>Text*</strong>
        <br />
        <Input
            onChange={(event) => {
                setSelectedQuickLink(prevState => ({
                    ...prevState,
                    text: event.target.value
                }));
            }}
            defaultValue={selectedQuickLink.text}
            label={"Text"}
            placeholder={"Type a text"}
            fullWidth
            inputProps={{ maxLength: 50 }}
            required
        />
        <br />
        <br />
        <strong>URL*</strong>
        <br />
        <Input
            onChange={(event) => {
                setSelectedQuickLink(prevState => ({
                    ...prevState,
                    url: event.target.value
                }));
            }}
            defaultValue={selectedQuickLink.url}
            label={"URL"}
            placeholder={"Type a URL"}
            fullWidth
            required
        />
        <span>make sure to add https://</span>
    </>
);